module.exports = __webpack_public_path__ + "img/p_重疾保障@2x.3678a6c7.png";